import { render } from "./QHLSExamRegistrationPublic.vue?vue&type=template&id=518dec2e&scoped=true"
import script from "./QHLSExamRegistrationPublic.vue?vue&type=script&lang=js"
export * from "./QHLSExamRegistrationPublic.vue?vue&type=script&lang=js"

import "./QHLSExamRegistrationPublic.vue?vue&type=style&index=0&id=518dec2e&scoped=true&lang=css"
import "./QHLSExamRegistrationPublic.vue?vue&type=style&index=1&id=518dec2e&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518dec2e"]])

export default __exports__